export enum EventTypeEnum {
  ONLINE = "Online",
  FACE_TO_FACE = "Yüz Yüze",
  WITHOUT_MEET = "Diyet Ataması",
}
